import React from "react";
import styles from "../styles";
import rea from "../assets/react.svg";
import js from "../assets/js.svg";
import unity from "../assets/unity.png";
import css from "../assets/css.png";
import html55 from "../assets/html5.png";
import redux from "../assets/redux.png";
import firebase from "../assets/firebase.png";
import tailwind from "../assets/tailwind.png";
import ts from "../assets/ts.png";

import cpp from "../assets/c++.png";
const Skills = () => {
  return (
    <section
      id="skills"
      className={`flex text-white gradient-05 ${styles.paddingX} ${styles.paddingY} w-full`}
    >
      <div className="flex flex-col justify-between gap-10 items-center">
        <p className="text-slate-400 lg:w-[50%] lg:text-start xs:w-[70%] xs:text-center">
          <h1 className="text-[50px] lg:text-start sm:text-center xs:text-center text-gradient font-semibold">
            Skills & Experience
          </h1>
          I have extensive experience with technologies like React, JavaScript,
          TailwindCSS, Styled Components, Firebase and Redux. I am well-known to
          frameworks like Three.js, Framer-motion and Flowbite. I'm currently
          trying to improve my Typescript skills and know a bit about Blockchain
          systems. <br /> Additionally, I have taken part in a number of
          hackathons, including the Huddle01 holiday hackathon, where I took
          second place, demonstrating my love for coding and my capacity to
          function under pressure.
          <br />
          I'm currently focusing on freelance projects. Additionally, I have 2
          months of experience working at a startup company named DesiLabs.{" "}
          <br />
          At DesiLabs, I got a lot of experience in Styled Components. I worked
          on creating multiple pages for the main website of the startup using
          Styled Components. I got a good grasp of adding animations as well. I
          also got some experience in TS.
          <br />
          I've been searching lately for Frontend Opportunities.
        </p>

        <div className="flex flex-col xs:flex-row flex-wrap flex-1 justify-between gap-4 xs:gap-8 items-center">
          <div className="flex flex-row gap-10 mx-auto">
            <img
              src={html55}
              alt="css"
              className="w-[50px] sm:w-[100px] transition ease-in-out hover:-translate-y-1 hover:scale-110 duration-300"
            />
            <img
              src={css}
              alt="css"
              className="w-[50px] sm:w-[100px] transition ease-in-out hover:-translate-y-1 hover:scale-110 duration-300"
            />
            <img
              src={js}
              alt="css"
              className="w-[50px] sm:w-[100px] transition ease-in-out hover:-translate-y-1 hover:scale-110 duration-300"
            />
          </div>
          <div className="flex flex-row gap-10 mx-auto">
            <img
              src={redux}
              alt="redux"
              className="w-[50px] sm:w-[100px] transition ease-in-out hover:-translate-y-1 hover:scale-110 duration-300"
            />
            <img
              src={firebase}
              alt="firebase"
              className="w-[50px] sm:w-[100px] transition ease-in-out hover:-translate-y-1 hover:scale-110 duration-300"
            />
            <img
              src={rea}
              alt="react"
              className="w-[50px] sm:w-[100px] transition ease-in-out hover:-translate-y-1 hover:scale-110 duration-300"
            />
          </div>
          <div className="flex flex-row gap-10 mx-auto">
            <img
              src={tailwind}
              alt="tailwind"
              className="w-[50px] sm:w-[100px] transition ease-in-out hover:-translate-y-1 hover:scale-110 duration-300"
            />
            <img
              src={ts}
              alt="ts"
              className="w-[50px] sm:w-[100px] transition ease-in-out hover:-translate-y-1 hover:scale-110 duration-300"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
